import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { SetupStatus } from '@core/models/setup/setup-status.model';
import { suppressGlobalErrorFeedback } from '@core/interceptors';
import { endpoints, environment } from '@environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SetupStatusService {
  private readonly http = inject(HttpClient);
  private readonly url = `${environment.apiUrl}/${endpoints.v1.setupStatus}`;

  getStatus(): Observable<SetupStatus> {
    return this.http.get<SetupStatus>(this.url, { context: suppressGlobalErrorFeedback() });
  }
}
